import React, { useState } from "react"; import { db } from "../firebase"; import { collection, getDocs, query, where, doc, updateDoc, deleteDoc, } from "firebase/firestore";

const AdminUserManager = () => { const [searchField, setSearchField] = useState("username"); const [searchValue, setSearchValue] = useState(""); const [users, setUsers] = useState([]); const [message, setMessage] = useState(""); const [editingUser, setEditingUser] = useState(null); const [editedData, setEditedData] = useState({});

const handleSearch = async (e) => { e.preventDefault(); setMessage(""); setUsers([]); setEditingUser(null);

if (!searchValue.trim()) {
  setMessage("Please enter a search value.");
  return;
}

try {
  const usersRef = collection(db, "users");
  const q = query(usersRef, where(searchField, "==", searchValue));
  const querySnapshot = await getDocs(q);

  if (querySnapshot.empty) {
    setMessage("No users found.");
    return;
  }

  const fetchedUsers = [];
  for (const docSnap of querySnapshot.docs) {
    const userData = docSnap.data();
    const userId = docSnap.id;

    // Find who referred this user
    const referrerQuery = query(
      usersRef,
      where("referralCode", "==", userData.whoReferredWho || "")
    );
    const referrerSnapshot = await getDocs(referrerQuery);
    const referrer =
      !referrerSnapshot.empty
        ? referrerSnapshot.docs[0].data().username
        : "Unknown";

    fetchedUsers.push({ id: userId, ...userData, referrer });
  }

  setUsers(fetchedUsers);
} catch (err) {
  console.error("Error fetching users:", err);
  setMessage("Failed to fetch users.");
}

};

const handleEdit = (user) => { setEditingUser(user); setEditedData(user); };

const handleUpdate = async () => { try { const userRef = doc(db, "users", editingUser.id); await updateDoc(userRef, editedData); setMessage("User updated successfully."); setEditingUser(null); setEditedData({}); } catch (err) { console.error("Error updating user:", err); setMessage("Failed to update user."); } };

const handleDelete = async (userId) => { try { await deleteDoc(doc(db, "users", userId)); setUsers(users.filter((user) => user.id !== userId)); setMessage("User deleted successfully."); } catch (err) { console.error("Error deleting user:", err); setMessage("Failed to delete user."); } };

const renderField = (label, field, type = "text") => ( <p> <strong>{label}:</strong>{" "} {editingUser && editingUser.id === editedData.id ? ( <input type={type} value={editedData[field] || ""} onChange={(e) => setEditedData({ ...editedData, [field]: e.target.value }) } /> ) : ( <span>{editedData[field]}</span> )} </p> );

return ( <div style={{ maxWidth: "800px", margin: "auto" }}> <h2>Admin User Manager</h2> <form onSubmit={handleSearch}> <select value={searchField} onChange={(e) => setSearchField(e.target.value)} > <option value="username">Username</option> <option value="fullName">Full Name</option> <option value="phoneNumber">Phone Number</option> <option value="referralCode">Referral Code</option> {/* Add more fields as needed */} </select> <input type="text" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} placeholder="Enter search value" /> <button type="submit">Search</button> </form>

{message && <p>{message}</p>}

  {users.map((user) => (
    <div
      key={user.id}
      style={{ border: "1px solid #ccc", padding: "10px", marginTop: "10px" }}
    >
      {editingUser && editingUser.id === user.id ? (
        <div>
          {renderField("Full Name", "fullName")}
          {renderField("Username", "username")}
          {renderField("Phone Number", "phoneNumber")}
          {renderField("Password", "password")}
          {renderField("Referral Code", "referralCode")}
          {renderField("Referral Link", "referralLink")}
          {renderField("Country", "country")}
          {renderField("Language", "language")}
          {renderField("Role", "role")}
          {renderField("Tsh Balance", "tshBalance", "number")}
          {renderField("USDT Balance", "usdtBalance", "number")}
          {renderField("Deposited Amount on Join Day", "depositedAmountOnJoinDay", "number")}
          {renderField("Who Referred Who", "whoReferredWho")}
          <p>
            <strong>Created At:</strong>{" "}
            {user.createdAt?.toDate ? user.createdAt.toDate().toString() : "N/A"}
          </p>
          <button onClick={handleUpdate}>Save</button>
          <button onClick={() => setEditingUser(null)}>Cancel</button>
        </div>
      ) : (
        <div>
          <p><strong>Full Name:</strong> {user.fullName}</p>
          <p><strong>Username:</strong> {user.username}</p>
          <p><strong>Phone Number:</strong> {user.phoneNumber}</p>
          <p><strong>Password:</strong> {user.password}</p>
          <p><strong>Referral Code:</strong> {user.referralCode}</p>
          <p><strong>Referral Link:</strong> <a href={user.referralLink} target="_blank" rel="noreferrer">{user.referralLink}</a></p>
          <p><strong>Country:</strong> {user.country}</p>
          <p><strong>Language:</strong> {user.language}</p>
          <p><strong>Role:</strong> {user.role}</p>
          <p><strong>Tsh Balance:</strong> {user.tshBalance}</p>
          <p><strong>USDT Balance:</strong> {user.usdtBalance}</p>
          <p><strong>Deposited Amount on Join Day:</strong> {user.depositedAmountOnJoinDay}</p>
          <p><strong>Who Referred Who:</strong> {user.whoReferredWho}</p>
          <p><strong>Referred By:</strong> {user.referrer}</p>
          <p><strong>Created At:</strong> {user.createdAt?.toDate ? user.createdAt.toDate().toString() : "N/A"}</p>
          <button onClick={() => handleEdit(user)}>Edit</button>
          <button onClick={() => handleDelete(user.id)}>Delete</button>
        </div>
      )}
    </div>
  ))}
</div>

); };

export default AdminUserManager;